export default __webpack_public_path__ + "static/idrottsskadeexperten-72956bf8b2a8abafc9328d876d1d6a34.png";